// src/components/Billing/PlanCard.js
import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  CardContent,
  Button,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
  Box,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

/**
 * Card de plan de suscripción.
 * Mostrado en la página Billing/Planes.
 */
function PlanCard({
  id,
  name,
  priceMonthly,
  priceAnnual,
  period,
  features,
  onSelect,
  popular,
  selected,
}) {
  const price = period === 'annual' ? priceAnnual : priceMonthly;

  return (
    <Card
      variant="outlined"
      sx={{
        borderColor: selected ? 'primary.main' : 'divider',
        position: 'relative',
        minWidth: 260,
        flex: 1,
      }}
    >
      {popular && (
        <Chip
          label="Popular"
          color="primary"
          size="small"
          sx={{ position: 'absolute', top: 12, right: 12 }}
        />
      )}
      <CardHeader title={name} sx={{ textAlign: 'center' }} />
      <CardContent sx={{ textAlign: 'center' }}>
        <Typography variant="h4" component="p" fontWeight={600}>
          ${price}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          por {period === 'annual' ? 'año' : 'mes'}
        </Typography>
        <Box mt={2}>
          <List dense>
            {features.map((feat) => (
              <ListItem key={feat}>
                <ListItemIcon>
                  <CheckIcon color="success" fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={<Typography variant="body2">{feat}</Typography>} />
              </ListItem>
            ))}
          </List>
        </Box>
        <Button
          variant={selected ? 'contained' : 'outlined'}
          fullWidth
          onClick={() => onSelect(id)}
          disabled={selected}
        >
          {selected ? 'Seleccionado' : 'Seleccionar Plan'}
        </Button>
      </CardContent>
    </Card>
  );
}

PlanCard.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  priceMonthly: PropTypes.number.isRequired,
  priceAnnual: PropTypes.number.isRequired,
  period: PropTypes.oneOf(['monthly', 'annual']).isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelect: PropTypes.func.isRequired,
  popular: PropTypes.bool,
  selected: PropTypes.bool,
};

PlanCard.defaultProps = {
  popular: false,
  selected: false,
};

export default PlanCard;
